import { createFileRoute, Outlet } from '@tanstack/react-router'
import { requireAuth } from '@/lib/middleware'

export const Route = createFileRoute('/_authenticated')({
  beforeLoad: async () => {
    return await requireAuth()
  },
  component: () => <Outlet />,
})
